import { grpc } from '@improbable-eng/grpc-web';
import { NodeHttpTransport } from '@improbable-eng/grpc-web-node-http-transport';

import { logger } from '~/utils/loggerUtil';
import { getGAParamsFromLocalStorage } from '~/utils/storageUtils';

import { GetConfigUtil } from '../shared/utils/envUtil';
import {
  ResetPasswordRequest,
  SignRequest,
  SignResponse,
  SignUtmRequest,
  UserResponse,
} from './proto/user-service/user_service_pb';
import { UserService } from './proto/user-service/user_service_pb_service';

export type User = UserResponse.AsObject;

grpc.setDefaultTransport(NodeHttpTransport());

const ENV_CONFIG = GetConfigUtil.getPublicStaticConfig();

type UtmParams = {
  utmContent: string;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
};

/**
 * SignUtmRequestを生成する
 * @param params
 */
export const createSignUtmRequest = (params: UtmParams) => {
  const request = new SignUtmRequest();
  request.setUtmContent(params.utmContent);
  request.setUtmSource(params.utmSource);
  request.setUtmCampaign(params.utmCampaign);
  request.setUtmMedium(params.utmMedium);
  return request;
};

/**
 *
 * @param token
 * @param email
 * @param utmParams
 */
export const cocolocalaSignGrpcRequest = (
  token: string,
  email: string
): Promise<SignResponse.AsObject> => {
  const request = new SignRequest();
  request.setToken(token);
  request.setEmail(email);
  const utmParams = getGAParamsFromLocalStorage();
  if (typeof utmParams !== 'undefined') {
    // NOTE: utm_source, utm_medium はそのままで入れて、utm_campaign には末尾に _email を付け足す
    // utm_source/utm_medium/utm_campaign のどれか一つでも空のストリングだった場合は、utm_source=system_mail utm_medium=email utm_campaign=signed_up とする
    // https://github.com/cocolocala/cocolocala-web/issues/2920#issuecomment-684673932
    request.setUtmParameters(
      createSignUtmRequest({
        utmContent: utmParams.utmContent,
        utmSource:
          utmParams.utmSource !== '' ? utmParams.utmSource : 'system_mail',
        utmMedium: utmParams.utmMedium !== '' ? utmParams.utmMedium : 'email',
        utmCampaign:
          utmParams.utmCampaign !== ''
            ? `${utmParams.utmCampaign}_email`
            : 'signed_up',
      })
    );
  }

  return new Promise((resolve, reject) => {
    grpc.unary(UserService.Sign, {
      request,
      host: ENV_CONFIG.USER_SERVICE_GRPC_HOST,
      metadata: {
        token,
      },
      onEnd: output => {
        if (output.status === grpc.Code.OK) {
          if (output.message) {
            const result = output.message.toObject() as SignResponse.AsObject;
            logger.debug('cocolocalaSignGrpcRequest ok', result);
            return resolve(result);
          }
        } else {
          logger.error('hit an error', JSON.stringify(output, null, 2));
          return reject({
            code: 'auth/user-service-sign-error',
          });
        }
      },
    });
  });
};

export const sendResetPasswordMail = (
  token: string,
  email: string
): Promise<void> => {
  const request = new ResetPasswordRequest();
  request.setEmail(email);
  return new Promise((resolve, reject) => {
    grpc.unary(UserService.SendResetPasswordMail, {
      request,
      host: ENV_CONFIG.USER_SERVICE_GRPC_HOST,
      metadata: {
        token,
      },
      onEnd: output => {
        if (output.status === grpc.Code.OK) {
          if (output.message) {
            const result = output.message.toObject();
            logger.debug('sendResetPasswordMail ok', result);
            return resolve();
          }
        } else {
          logger.error('hit an error', output);
          return reject(output);
        }
      },
    });
  });
};
